import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(Alert,$scope,$rootScope,$state,UserNotesService,ShowNoteModal,ConfirmDeleteModal,$timeout) {
        this.Alert = Alert;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.UserNotesService = UserNotesService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
    }
    
    
     $onInit() {
        this.keepLockerOnServer = this.$rootScope.account.keepLockerOnServer;
        const format = date => new Date(date).toString().slice(4, 24);
        this.notes.forEach(note => note.updatedOnDisplay = format(note.updatedOn));

        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.Alert('success', 'global.data_copied')
            })
        })
    }
    
    showNote(note){
		this.ShowNoteModal(note.text);
	}

    deleteNote(note){
        this.isRemoving = true;
        this.ConfirmDeleteModal('company.sharing-center.confirm_company_note_delete')
            .then(() => this.UserNotesService.delete({id : note.id}).$promise)
            .then(() => {
                this.notes.splice(this.notes.indexOf(note), 1);
                this.Alert('success', 'company.sharing-center.note.manage.removed');
            })
            .finally(() => this.isRemoving = false)
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/user/notes/notes.controller.js